<template>
  <b-container class="mt-5 text-center">
    <div v-if="events && approvedCommunityList">
      <div v-if="approvedCommunityList.length === 0">
        <b-alert
          show
          variant="warning"
        >
          イベントを作成して公開する前にコミュニティを作成してみましょう！
        </b-alert>
      </div>
      <div v-else-if="events.length === 0">
        <b-alert
          show
          variant="info"
        >
          イベントを作成してみましょう！
        </b-alert>
      </div>
      <b-row class="justify-content-center">
        <EventCard
          v-for="event in events"
          :key="event.slug"
          :event="event"
          col-size="8"
        />
      </b-row>
      <b-row class="justify-content-center mb-5 mt-5">
        <b-col
          cols="12"
          sm="6"
        >
          <b-button
            variant="primary"
            class="mt-2"
            block
            size="lg"
            :to="{name: createButton.url}"
          >
            {{ createButton.title }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <Loader v-if="eventStatus === 'loading'" />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {COMMUNITY_REQUEST, EVENT_REQUEST} from "@/store/constant";
import {getImage} from "@/helpers";
import EventCard from "@/modules/EventCard";
import Loader from "@/components/Loader";

export default {
  name: 'EventList',
  components: {Loader, EventCard},
  computed: {
    ...mapGetters(['events', 'approvedCommunityList', 'eventStatus']),
    createButton() {
      return this.approvedCommunityList.length === 0 ?{title: 'コミュニティを作成', url: 'community-create'} :{title: 'イベントを作成', url: 'event-create'};
    },
  },
  mounted() {
    this.getEventList();
    this.getCommunityList();
  },
  methods: {
    getEventList() {
      this.$store.dispatch(EVENT_REQUEST);
    },
    getCommunityList() {
      this.$store.dispatch(COMMUNITY_REQUEST, this.$route.params.id);
    },
    getImage
  }
}
</script>
